import {Navigate} from 'react-router';
import DashboardLayout from 'src/components/DashboardLayout';
import MainLayout from 'src/components/MainLayout';
import OfferList from 'src/pages/OfferList';
import Login from 'src/pages/Login';
import NotFound from 'src/pages/NotFound';
import React from "react";
import Logout from "./components/account/Logout";
import AkolLogs from "./pages/AkolLogs";
import ConfigAttributes from "./pages/ConfigAttributes";
import IncorrectOffers from "./pages/IncorrectOffers";
import AkolDealers from "./pages/AkolDealers";
import LeasingMatrix from "./pages/LeasingMatrix";
import CreditLoanMatrix from "./pages/CreditLoanMatrix";
import ImportOffersFromExcelPage from './pages/ImportOffersFromExcelPage';
import ColorStandardizationPage from "./pages/ColorStandardizationPage";

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'offers', element: <OfferList /> },
      { path: 'incorrectOffers', element: <IncorrectOffers /> },
      { path: 'leasingMatrix', element: <LeasingMatrix /> },
      { path: 'creditLoanMatrix', element: <CreditLoanMatrix /> },
      { path: 'importOffers', element: <ImportOffersFromExcelPage /> },
      { path: '/', element: <Navigate to="/app/offers"  /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'login',
    element: <Login />
  },
  {
    path: 'logout',
    element: <Logout />
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: '404', element: <NotFound /> },
      { path: '/', element: <Navigate to="/app/offers" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'akol',
    element: <DashboardLayout />,
    children: [
      { path: 'logs', element: <AkolLogs /> },
      { path: 'dealers', element: <AkolDealers /> },
      { path: '/', element: <Navigate to="/akol/logs"  /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'conf',
    element: <DashboardLayout />,
    children: [
      { path: 'attributes', element: <ConfigAttributes /> },
      { path: 'colors', element: <ColorStandardizationPage /> },
      { path: '/', element: <Navigate to="/akol/attributes"  /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
